import { render, staticRenderFns } from "./PageCover.vue?vue&type=template&id=7d96f844&"
import script from "./PageCover.vue?vue&type=script&lang=ts&"
export * from "./PageCover.vue?vue&type=script&lang=ts&"
import style0 from "./PageCover.vue?vue&type=style&index=0&id=7d96f844&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports